// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-margin-padding[data-v-3c430bce]{margin:0;padding:0}.margin-left-sm[data-v-3c430bce]{margin-left:8px}.assignment[data-v-3c430bce]{color:var(--xml-viewer-assignment-color)}.quote[data-v-3c430bce]{color:var(--xml-viewer-quote-color)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
